import { render, staticRenderFns } from "./PopupReferences.vue?vue&type=template&id=137e66ae&"
import script from "./PopupReferences.vue?vue&type=script&lang=js&"
export * from "./PopupReferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports